export enum BusinessTypeName {
  AAHA = 'AAHA',
  ANALYTICS = 'Analytics',
  PHONE = 'Boop/Mobile App',
  PIMS = 'PIMs',
  WELLNESS = 'Wellness Plans',
  OMNICHANNEL = 'OmniChannel',
  CVC = 'Chewy Vet Care',
}
